<template>
    <div>
        <div v-if="loading" class="loading"/>

        <div class="top-right-button-container">
            <b-button v-b-modal.supplier_form @click="edit = false" variant="primary" size="sm" class="top-right-button"
                      v-text="'ADD NEW'"/>
        </div>

        <piaf-breadcrumb heading="Suppliers List"/>

        <div class="d-flex flex-row">
            <span class="iconsminds-add mr-3 menu-icon-style"/>

            <p class="my-auto">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet commodi dolores quod,
                repellendus similique sint. Ad, corporis culpa delectus est in ipsum laboriosam nostrum
                officiis quia quos rem totam vitae.
            </p>
        </div>

        <div class="my-2">
            <div class="d-block d-md-inline-block pt-1">
                <b-dropdown :text="'Order by: ' + meta.order_by"
                            variant="outline-dark" class="mr-1 float-md-left btn-group" size="xs">

                    <b-dropdown-item v-for="(field,index) in table_fields.slice(0, -1)"
                                     v-if="field.sortable === true" :key="index"
                                     @click="changeOrderBy(field.key, field.label)">{{ field.label }}
                    </b-dropdown-item>
                </b-dropdown>

                <div class="search-sm d-inline-block float-md-left ml-1 align-top">
                    <b-input placeholder="Search" @input="searchSupplier" v-model="meta.search"/>
                </div>
            </div>

            <div class="float-md-right pt-1">
                <span class="text-muted text-small mr-1 mb-2">{{meta.from}}-{{meta.to}} of {{ meta.total }}</span>

                <b-dropdown right :text="meta.per_page.toString()" variant="outline-dark"
                            class="d-inline-block" size="xs">
                    <b-dropdown-item v-for="(size,index) in meta.page_sizes" :key="index"
                                     @click="changePageSize(size)">{{ size }}
                    </b-dropdown-item>
                </b-dropdown>
            </div>
        </div>

        <div class="separator mb-4"></div>

        <b-card class="mb-4" :title="'Suppliers List'">

            <b-refresh-button class="text-data-link" @click="refreshData"/>

            <b-table :key="tableKey" show-empty no-sort-reset class="vuetable" :sort-by="meta.sort_by"
                     :sort-desc="meta.sort_desc" @sort-changed="changeSorting" :per-page="meta.per_page"
                     :current-page="meta.current_page" :fields="table_fields" :items="fetchSuppliers">
                <template v-slot:cell(id)="data">
                    <span v-text="data.item.data.attributes.code"/>
                </template>

                <template v-slot:cell(company)="data">
                     <span @click="supplierDetails(data.item)" style="cursor: pointer;" class="text-data-link"
                           v-text="data.item.data.attributes.company"/>
                </template>

                <template v-slot:cell(dba)="data">
                    <span v-text="data.item.data.attributes.dba"/>
                </template>

                <template v-slot:cell(ein)="data">
                    <span v-text="data.item.data.attributes.ein"/>
                </template>

                <template v-slot:cell(opening_balance)="data">
                    <span v-text="data.item.data.attributes.opening_balance"/>
                </template>

                <template v-slot:cell(address)="data">
                    <span v-text="data.item.data.attributes.address"/>
                </template>

                <template v-slot:cell(city)="data">
                    <span v-text="data.item.data.attributes.city"/>
                </template>

                <template v-slot:cell(state)="data">
                    <span v-text="data.item.data.attributes.state"/>
                </template>

                <template v-slot:cell(zip)="data">
                    <span v-text="data.item.data.attributes.zip"/>
                </template>

                <template v-slot:cell(contact_person)="data">
                    <span v-text="data.item.data.attributes.contact_person"/>
                </template>

                <template v-slot:cell(phone)="data">
                    <span v-text="data.item.data.attributes.phone"/>
                </template>

                <template v-slot:cell(fax)="data">
                    <span v-text="data.item.data.attributes.fax"/>
                </template>

                <template v-slot:cell(email)="data">
                    <span v-text="data.item.data.attributes.email"/>
                </template>

                <template v-slot:cell(actions)="data">
                    <b-dropdown variant="empty" class="my-auto dropright" size="xs"
                                menu-class="mt-2" style="width: 75px;" right no-caret>

                        <template slot="button-content">
                            <i class="btn-circle simple-icon-options-vertical"/>
                        </template>

                        <b-dropdown-item @click="editSupplier(data.item.supplier_id)">
                            Edit
                        </b-dropdown-item>

                        <b-dropdown-item @click="deleteSupplier(data.item)">
                            Delete
                        </b-dropdown-item>
                    </b-dropdown>
                </template>
            </b-table>
            <b-pagination size="sm" align="center" :total-rows="meta.total" :per-page="meta.per_page"
                          v-model="meta.current_page">
                <template v-slot:next-text>
                    <i class="simple-icon-arrow-right"/>
                </template>

                <template v-slot:prev-text>
                    <i class="simple-icon-arrow-left"/>
                </template>

                <template v-slot:first-text>
                    <i class="simple-icon-control-start"/>
                </template>

                <template v-slot:last-text>
                    <i class="simple-icon-control-end"/>
                </template>
            </b-pagination>
        </b-card>
        <SupplierFormModal :edit="edit" @updated="tableKey++"/>

        <SupplierDeleteModal v-if="supplier" :client="supplier" @updated="tableKey++"/>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import SupplierFormModal from "./modals/SupplierFormModal";
import SupplierDeleteModal from "./modals/SupplierDeleteModal";

export default {
    name: "Lists",

    components: {
        SupplierFormModal,
        SupplierDeleteModal,
    },

    data() {
        return {
            loading: false,
            edit: false,
            tableKey: 0,
            supplier: null,
        }
    },

    computed: {
        ...mapGetters({
            meta: 'getSupplierMeta',
            table_fields: 'getSupplierTableFields',
        })
    },

    methods: {
        changeOrderBy(key, label) {
            this.meta.order_by = label;
            this.meta.sort_by = key;
        },

        searchSupplier: _.debounce(function (event) {
            if (this.meta.search && this.meta.search.length >= 3) {
                this.meta.current_page === 1 ? this.tableKey++ : this.meta.current_page = 1;
            }
        }, 300),

        changePageSize(per_page) {
            this.meta.per_page = per_page;
        },

        refreshData() {
            this.$store.commit('resetSuppliersMeta');
            this.meta.current_page === 1 ? this.tableKey++ : this.meta.current_page = 1;
        },

        changeSorting(event) {
            (event.sortDesc ? this.meta.sort = 'desc' : this.meta.sort = 'asc') && (this.meta.sort_by = event.sortBy);
        },

        fetchSuppliers() {
            return this.$store.dispatch('fetchSuppliers')
                .then(suppliers => {
                    return suppliers.data;
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        supplierDetails(supplier) {
            this.supplier = supplier;

            setTimeout(() => {
                this.$bvModal.show('details');
            }, 1);
        },

        editSupplier(supplier_id) {
            this.edit = true;

            this.$store.dispatch('fetchEditSupplier', supplier_id)
                .finally(response => {
                    this.$bvModal.show('supplier_form');
                });
        },

        deleteSupplier(supplier) {
            this.supplier = supplier;

            setTimeout(() => {
                this.$bvModal.show('supplier_delete');
            }, 1);
        },
    }
}
</script>

<style scoped>

</style>
